"use client";

import React from "react";

// Duotone icons from Figma
const OpenKeyholeIcon = () => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-full"
  >
    <path
      opacity="0.6"
      d="M10 6.11114V7.77781H12.2222V6.11114C12.2222 4.57642 13.4653 3.33337 15 3.33337C16.5347 3.33337 17.7778 4.57642 17.7778 6.11114V7.77781C17.7778 8.39239 18.2743 8.88892 18.8889 8.88892C19.5035 8.88892 20 8.39239 20 7.77781V6.11114C20 3.35073 17.7604 1.11115 15 1.11115C12.2396 1.11115 10 3.35073 10 6.11114Z"
      fill="white"
    />
    <path
      d="M2.22222 7.77771C0.996528 7.77771 0 8.77424 0 9.99993V16.6666C0 17.8923 0.996528 18.8888 2.22222 18.8888H13.3333C14.559 18.8888 15.5556 17.8923 15.5556 16.6666V9.99993C15.5556 8.77424 14.559 7.77771 13.3333 7.77771H2.22222ZM8.88889 14.4444H6.66667C6.05208 14.4444 5.55556 13.9478 5.55556 13.3333C5.55556 12.7187 6.05208 12.2222 6.66667 12.2222H8.88889C9.50347 12.2222 10 12.7187 10 13.3333C10 13.9478 9.50347 14.4444 8.88889 14.4444Z"
      fill="white"
    />
  </svg>
);

const StethoscopeIcon = () => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-full"
  >
    <g clipPath="url(#stethoscope-clip)">
      <path
        opacity="0.6"
        d="M4.89619 13.4556C5.08828 13.4932 5.28413 13.5234 5.47999 13.5422C5.57792 13.5535 5.67961 13.561 5.77754 13.5648C5.82651 13.5686 5.87924 13.5686 5.9282 13.5686C5.97716 13.5686 6.0299 13.5686 6.07886 13.5686C6.5007 13.5686 6.91125 13.5234 7.31426 13.4631C7.56285 15.561 9.3444 17.1882 11.5064 17.1882C13.8378 17.1882 15.7248 15.3012 15.7248 12.9697V10.3068C15.9094 10.3859 16.1052 10.4499 16.3048 10.4914C16.4065 10.514 16.5082 10.529 16.6137 10.5403C16.6664 10.5441 16.7192 10.5516 16.7719 10.5516C16.8246 10.5516 16.8774 10.5554 16.9339 10.5554C17.3632 10.5554 17.77 10.465 18.1391 10.303V12.9659C18.1391 16.627 15.1711 19.5949 11.5101 19.5949C8.01106 19.5949 5.14854 16.8868 4.89995 13.4518L4.89619 13.4556Z"
        fill="white"
      />
      <path
        d="M3.44985 2.66477C4.08262 2.45385 4.4216 1.77212 4.21068 1.13935C3.99975 0.506579 3.31802 0.167596 2.68902 0.374752L1.70597 0.702436C0.71915 1.03389 0.05625 1.95291 0.05625 2.99246V7.54613C0.05625 10.8757 2.75305 13.5725 6.08262 13.5725C9.41218 13.5725 12.109 10.8757 12.109 7.54613V2.99246C12.109 1.95667 11.4461 1.03389 10.4593 0.706203L9.47621 0.374752C8.84344 0.16383 8.16171 0.506579 7.95079 1.13558C7.73987 1.76458 8.08262 2.45008 8.71162 2.661L9.69844 2.99246V7.54613C9.69844 9.54236 8.07885 11.1619 6.08262 11.1619C4.08638 11.1619 2.4668 9.54236 2.4668 7.54613V2.99246L3.44985 2.66477ZM18.1353 7.54613C18.1353 7.86579 18.0084 8.17235 17.7823 8.39838C17.5563 8.62442 17.2497 8.7514 16.9301 8.7514C16.6104 8.7514 16.3039 8.62442 16.0778 8.39838C15.8518 8.17235 15.7248 7.86579 15.7248 7.54613C15.7248 7.22647 15.8518 6.9199 16.0778 6.69387C16.3039 6.46784 16.6104 6.34085 16.9301 6.34085C17.2497 6.34085 17.5563 6.46784 17.7823 6.69387C18.0084 6.9199 18.1353 7.22647 18.1353 7.54613ZM16.9301 4.53294C16.1309 4.53294 15.3645 4.8504 14.7994 5.41549C14.2344 5.98057 13.9169 6.74698 13.9169 7.54613C13.9169 8.34527 14.2344 9.11169 14.7994 9.67677C15.3645 10.2419 16.1309 10.5593 16.9301 10.5593C17.7292 10.5593 18.4956 10.2419 19.0607 9.67677C19.6258 9.11169 19.9433 8.34527 19.9433 7.54613C19.9433 6.74698 19.6258 5.98057 19.0607 5.41549C18.4956 4.8504 17.7292 4.53294 16.9301 4.53294Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="stethoscope-clip">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CreditCardIcon = () => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-full"
  >
    <path
      opacity="0.6"
      d="M0 4.44451V5.55562H20V4.44451C20 3.21882 19.0035 2.22229 17.7778 2.22229H2.22222C0.996528 2.22229 0 3.21882 0 4.44451ZM0 8.88896V15.5556C0 16.7813 0.996528 17.7778 2.22222 17.7778H17.7778C19.0035 17.7778 20 16.7813 20 15.5556V8.88896H0ZM3.33333 13.889C3.33333 13.5834 3.58333 13.3334 3.88889 13.3334H6.11111C6.41667 13.3334 6.66667 13.5834 6.66667 13.889C6.66667 14.1945 6.41667 14.4445 6.11111 14.4445H3.88889C3.58333 14.4445 3.33333 14.1945 3.33333 13.889ZM7.77778 13.889C7.77778 13.5834 8.02778 13.3334 8.33333 13.3334H12.7778C13.0833 13.3334 13.3333 13.5834 13.3333 13.889C13.3333 14.1945 13.0833 14.4445 12.7778 14.4445H8.33333C8.02778 14.4445 7.77778 14.1945 7.77778 13.889Z"
      fill="white"
    />
    <path d="M20 8.88875H0V5.55542H20V8.88875Z" fill="white" />
  </svg>
);

// Trial step icon wrapper
const TrialIcon = ({ type }: { type: "now" | "ongoing" | "day14" }) => {
  return (
    <div className="bg-[#00a1c5] flex items-center justify-center rounded-full shrink-0 size-[40px]">
      <div className="size-[20px]">
        {type === "now" && <OpenKeyholeIcon />}
        {type === "ongoing" && <StethoscopeIcon />}
        {type === "day14" && <CreditCardIcon />}
      </div>
    </div>
  );
};

/**
 * "How your trial works" card section
 * Displays the 3-step trial process: Now, Ongoing, Day 14
 */
export function HowTrialWorks() {
  return (
    <div className="bg-[rgba(241,249,252,0.05)] border border-[rgba(255,255,255,0.08)] rounded-[16px] w-full">
      <div className="flex flex-col gap-[16px] items-center px-[16px] py-[24px]">
        <p className="font-normal leading-[28px] text-[20px] text-white text-center tracking-[0.2px] w-full">
          How your trial works
        </p>

        <div className="relative w-full">
          {/* Gradient background container - positioned behind circles */}
          <div
            className="absolute left-0 top-0 bottom-0 w-[48px] rounded-t-[100px]"
            style={{
              background:
                "linear-gradient(to bottom, rgba(0, 161, 197, 0.35) 0%, rgba(12, 40, 54, 0) 100%)",
            }}
          />

          {/* Content rows - each row pairs circle container with text block */}
          <div className="relative flex flex-col gap-[20px]">
            {/* Row 1: Now */}
            <div className="flex gap-[16px] items-start">
              <div className="flex items-start justify-center shrink-0 w-[48px] p-[4px] self-stretch">
                <TrialIcon type="now" />
              </div>
              <div className="flex flex-col flex-1">
                <p className="font-normal leading-[24px] text-[16px] text-white tracking-[0.08px]">
                  Now
                </p>
                <p className="font-normal leading-[22px] text-[15px] text-slate-50 tracking-[0.25px]">
                  Get round-the-clock access to Board-Certified Doctor care,{" "}
                  <span className="text-[#47c2de]">free for 14 days</span>
                </p>
              </div>
            </div>

            {/* Row 2: Ongoing */}
            <div className="flex gap-[16px] items-start">
              <div className="flex items-start justify-center shrink-0 w-[48px] p-[4px] self-stretch">
                <TrialIcon type="ongoing" />
              </div>
              <div className="flex flex-col flex-1">
                <p className="font-normal leading-[24px] text-[16px] text-white tracking-[0.08px]">
                  Ongoing
                </p>
                <p className="font-normal leading-[22px] text-[15px] text-slate-50 tracking-[0.25px]">
                  Request treatment for you or your family members with{" "}
                  <span className="text-[#47c2de]">no limits</span> or caps.
                </p>
              </div>
            </div>

            {/* Row 3: Day 14 */}
            <div className="flex gap-[16px] items-start">
              <div className="flex items-start justify-center shrink-0 w-[48px] p-[4px] self-stretch">
                <TrialIcon type="day14" />
              </div>
              <div className="flex flex-col flex-1">
                <p className="font-normal leading-[24px] text-[16px] text-white tracking-[0.08px]">
                  Day 14
                </p>
                <p className="font-normal leading-[22px] text-[15px] text-slate-50 tracking-[0.25px]">
                  Your first payment is due. You&apos;ll be charged according to
                  the plan & pricing you signed up for.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
